module.exports = __webpack_public_path__ + "img/person.97fea326.png";